import styled from 'styled-components';

const appSize = {
  xxs: '25px',
  xs: '40px',
  sm: '55px',
  md: '70px',
  lg: '85px',
  xl: '100px',
  xxl: '115px'
};

const StyledApp = styled.div`
  width: ${(props) => appSize[props.size]};
  height: ${(props) => appSize[props.size]};
  min-width: ${(props) => appSize[props.size]};
  min-height: ${(props) => appSize[props.size]};
  background-size: cover;
  background-image: url(${(props) => props.src});
  box-shadow: ${(props) => props.shadow && props.theme.shadows.depth1};
`;

export const App = StyledApp;